export const CorrectionRequestEntityType = {
  ProductionPlaces: 'production_places',
  SupplyChainInformations: 'supply_chain_informations',
  CommodityOriginDocuments: 'commodity_origin_documents',
} as const;

export type CorrectionRequestEntityType =
  (typeof CorrectionRequestEntityType)[keyof typeof CorrectionRequestEntityType];

export type CorrectionRequest = {
  id: string;
  entityType: CorrectionRequestEntityType;
  entityId: string;
  comment: string;
  requestedBy: string;
  isResolved: boolean;
  createdAt: string;
  updatedAt: string | null;
};
